var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "Modal",
        {
          attrs: {
            width: 1300,
            draggable: "",
            "footer-hide": true,
            title: "定单明细",
          },
          model: {
            value: _vm.show,
            callback: function ($$v) {
              _vm.show = $$v
            },
            expression: "show",
          },
        },
        [
          _c(
            "div",
            {
              staticClass: "add-wrap",
              staticStyle: {
                "max-height": "620px",
                "overflow-y": "auto",
                "overflow-x": "hidden",
              },
            },
            [
              _c(
                "Card",
                {
                  staticStyle: {
                    position: "relative",
                    "padding-bottom": "80px",
                  },
                  attrs: { padding: 0, bordered: false, "dis-hover": true },
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "global-tool-bar",
                      staticStyle: { "padding-top": "16px" },
                    },
                    [
                      _c("div", { staticClass: "left-bar" }),
                      _c(
                        "div",
                        { staticClass: "right-bar" },
                        [
                          _c(
                            "Poptip",
                            {
                              staticStyle: { "text-align": "left" },
                              attrs: {
                                confirm: "",
                                placement: "bottom-end",
                                title: "请确认新增定单信息是否无误？",
                              },
                              on: {
                                "on-ok": _vm.addToPreSaleCart,
                                "on-cancel": _vm.cancel,
                              },
                            },
                            [
                              _c("Button", { attrs: { type: "primary" } }, [
                                _vm._v("保存"),
                              ]),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ]
                  ),
                  _c(
                    "Row",
                    { attrs: { gutter: 24 } },
                    [
                      _c(
                        "Col",
                        { attrs: { span: "24" } },
                        [
                          _c(
                            "Form",
                            {
                              staticClass: "form-input-no-outline",
                              attrs: { "label-position": "top" },
                            },
                            [
                              _c(
                                "Row",
                                { attrs: { gutter: 24 } },
                                [
                                  _c(
                                    "Col",
                                    { attrs: { span: "6" } },
                                    [
                                      _c(
                                        "FormItem",
                                        { attrs: { label: "苗场" } },
                                        [
                                          _c(
                                            "Select",
                                            {
                                              attrs: {
                                                filterable: "",
                                                clearable: "",
                                                placeholder: "请选择苗场",
                                                disabled: _vm.$checkAccessArray(
                                                  ["B"]
                                                ),
                                              },
                                              on: {
                                                "on-change":
                                                  _vm.onSeedFarmChange,
                                              },
                                              model: {
                                                value:
                                                  _vm.preSaleOrderRecordVO
                                                    .seedFarmUuid,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.preSaleOrderRecordVO,
                                                    "seedFarmUuid",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "\n                                                preSaleOrderRecordVO.seedFarmUuid\n                                            ",
                                              },
                                            },
                                            _vm._l(
                                              _vm.seedFarmList,
                                              function (item) {
                                                return _c(
                                                  "Option",
                                                  {
                                                    key: item.seedFarmUuid,
                                                    attrs: {
                                                      value: item.seedFarmUuid,
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        item.seedFarmCode
                                                      ) +
                                                        "-" +
                                                        _vm._s(
                                                          item.seedFarmName
                                                        ) +
                                                        "\n                                            "
                                                    ),
                                                  ]
                                                )
                                              }
                                            ),
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "Col",
                                    { attrs: { span: "6" } },
                                    [
                                      _c(
                                        "FormItem",
                                        { attrs: { label: "周次" } },
                                        [
                                          _c(
                                            "Select",
                                            {
                                              attrs: {
                                                placeholder: "选择周次",
                                                disabled:
                                                  !_vm.chooseProductUuid,
                                              },
                                              on: {
                                                "on-change":
                                                  _vm.onWeekSelectChange,
                                              },
                                              model: {
                                                value:
                                                  _vm.preSaleOrderRecordVO
                                                    .selectedWeek,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.preSaleOrderRecordVO,
                                                    "selectedWeek",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "\n                                                preSaleOrderRecordVO.selectedWeek\n                                            ",
                                              },
                                            },
                                            _vm._l(
                                              _vm.filterModel.weekList,
                                              function (week) {
                                                return _c(
                                                  "Option",
                                                  {
                                                    key: week.weekKnownText,
                                                    attrs: {
                                                      value: week.weekKnownText,
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                                                " +
                                                        _vm._s(
                                                          week.weekKnownTextCh
                                                        ) +
                                                        "(" +
                                                        _vm._s(
                                                          week.weekBeginDate
                                                        ) +
                                                        "~" +
                                                        _vm._s(
                                                          week.weekEndDate
                                                        ) +
                                                        ")\n                                            "
                                                    ),
                                                  ]
                                                )
                                              }
                                            ),
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "Col",
                                    { attrs: { span: "6" } },
                                    [
                                      _c(
                                        "FormItem",
                                        { attrs: { label: "发货时间" } },
                                        [
                                          _c(
                                            "Select",
                                            {
                                              attrs: {
                                                placeholder: "选择发货日期",
                                                disabled:
                                                  !_vm.chooseProductUuid,
                                              },
                                              model: {
                                                value:
                                                  _vm.preSaleOrderRecordVO
                                                    .selectDay,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.preSaleOrderRecordVO,
                                                    "selectDay",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "\n                                                preSaleOrderRecordVO.selectDay\n                                            ",
                                              },
                                            },
                                            _vm._l(
                                              _vm.filterModel.dayList,
                                              function (day) {
                                                return _c(
                                                  "Option",
                                                  {
                                                    key: day,
                                                    attrs: { value: day },
                                                  },
                                                  [_vm._v(_vm._s(day))]
                                                )
                                              }
                                            ),
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "Col",
                                    { attrs: { span: "4" } },
                                    [
                                      _c(
                                        "FormItem",
                                        { attrs: { label: "客户名称" } },
                                        [
                                          _c("Input", {
                                            attrs: {
                                              value:
                                                _vm.preSaleOrderRecordVO
                                                  .userExternalCustomerName,
                                              disabled: "",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "Col",
                                    { attrs: { span: "4" } },
                                    [
                                      _c(
                                        "FormItem",
                                        { attrs: { label: "联系方式" } },
                                        [
                                          _c("Input", {
                                            attrs: {
                                              value:
                                                _vm.preSaleOrderRecordVO
                                                  .contactNumber,
                                              disabled: "",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "Col",
                                    { attrs: { span: "4" } },
                                    [
                                      _c(
                                        "FormItem",
                                        { attrs: { label: "客户经理" } },
                                        [
                                          _c("Input", {
                                            staticClass: "customerColor",
                                            attrs: {
                                              value:
                                                _vm.preSaleOrderRecordVO
                                                  .customerName,
                                              disabled: "",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _c(
                                "Row",
                                { attrs: { gutter: 24 } },
                                [
                                  _c(
                                    "Col",
                                    { attrs: { span: "12" } },
                                    [
                                      _c(
                                        "FormItem",
                                        { attrs: { label: "收货地址" } },
                                        [
                                          _c("Input", {
                                            attrs: {
                                              value:
                                                _vm.preSaleOrderRecordVO
                                                  .receiptFullAddress,
                                              disabled: "",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "Col",
                                    { attrs: { span: "12" } },
                                    [
                                      _c(
                                        "FormItem",
                                        { attrs: { label: "苗场备注" } },
                                        [
                                          _c("Input", {
                                            attrs: { type: "textarea" },
                                            model: {
                                              value:
                                                _vm.preSaleOrderRecordVO.remark,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.preSaleOrderRecordVO,
                                                  "remark",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "\n                                                preSaleOrderRecordVO.remark\n                                            ",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _c(
                                "Row",
                                { attrs: { gutter: 24 } },
                                [
                                  _c(
                                    "Col",
                                    { attrs: { span: "24" } },
                                    [
                                      _vm.$checkAccessArray(["B", "C", "G"])
                                        ? _c(
                                            "div",
                                            {
                                              staticStyle: {
                                                width: "100%",
                                                "text-align": "right",
                                                "padding-bottom": "10px",
                                              },
                                            },
                                            [
                                              _c(
                                                "Button",
                                                {
                                                  attrs: { type: "success" },
                                                  on: {
                                                    click: _vm.addNewProductRow,
                                                  },
                                                },
                                                [_vm._v("新增产品")]
                                              ),
                                            ],
                                            1
                                          )
                                        : _vm._e(),
                                      _c(
                                        "FormItem",
                                        [
                                          _c("Table", {
                                            attrs: {
                                              border: "",
                                              columns: _vm.orderDetail.columns,
                                              data: _vm.orderDetail.tableData,
                                            },
                                            scopedSlots: _vm._u([
                                              {
                                                key: "index",
                                                fn: function ({ row, index }) {
                                                  return [
                                                    _vm._v(
                                                      "\n                                                " +
                                                        _vm._s(index + 1) +
                                                        "\n                                            "
                                                    ),
                                                  ]
                                                },
                                              },
                                              {
                                                key: "productUuid",
                                                fn: function ({ row, index }) {
                                                  return [
                                                    _c(
                                                      "Select",
                                                      {
                                                        key: row._rowId,
                                                        staticStyle: {
                                                          "text-align": "left",
                                                        },
                                                        attrs: {
                                                          placeholder:
                                                            "选择编码或品名",
                                                          filterable: "",
                                                        },
                                                        on: {
                                                          "on-open-change": (
                                                            status
                                                          ) =>
                                                            _vm.handleOpenChange(
                                                              status,
                                                              index
                                                            ),
                                                          "on-change": (
                                                            value
                                                          ) =>
                                                            _vm.onProductSelectChange(
                                                              row,
                                                              index
                                                            ),
                                                        },
                                                        model: {
                                                          value:
                                                            row.productUuid,
                                                          callback: function (
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              row,
                                                              "productUuid",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "row.productUuid",
                                                        },
                                                      },
                                                      _vm._l(
                                                        _vm.orderDetail
                                                          .tableData[index]
                                                          .filterProductList,
                                                        function (item) {
                                                          return _c(
                                                            "Option",
                                                            {
                                                              key: item.productUuid,
                                                              attrs: {
                                                                value:
                                                                  item.productUuid,
                                                              },
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  item.productCode
                                                                ) +
                                                                  "-" +
                                                                  _vm._s(
                                                                    item.productName
                                                                  ) +
                                                                  "\n                                                    "
                                                              ),
                                                            ]
                                                          )
                                                        }
                                                      ),
                                                      1
                                                    ),
                                                  ]
                                                },
                                              },
                                              {
                                                key: "orderQuantity",
                                                fn: function ({ row, index }) {
                                                  return [
                                                    _c("InputNumber", {
                                                      key: row._rowId,
                                                      attrs: {
                                                        min: 0,
                                                        "active-change": false,
                                                        max: row.preSalePlanOfferAmount,
                                                        step: row.productIncreaseStepAmount,
                                                        precision:
                                                          row.isRounded == 1
                                                            ? 0
                                                            : 2,
                                                      },
                                                      on: {
                                                        "on-change": (value) =>
                                                          _vm.saveCurRow(
                                                            row,
                                                            index
                                                          ),
                                                      },
                                                      model: {
                                                        value:
                                                          row.orderQuantity,
                                                        callback: function (
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            row,
                                                            "orderQuantity",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "\n                                                        row.orderQuantity\n                                                    ",
                                                      },
                                                    }),
                                                  ]
                                                },
                                              },
                                              {
                                                key: "action",
                                                fn: function ({ row, index }) {
                                                  return [
                                                    _c(
                                                      "div",
                                                      [
                                                        _c(
                                                          "Button",
                                                          {
                                                            on: {
                                                              click: function (
                                                                $event
                                                              ) {
                                                                return _vm.dels(
                                                                  row,
                                                                  index
                                                                )
                                                              },
                                                            },
                                                          },
                                                          [_vm._v("删除")]
                                                        ),
                                                      ],
                                                      1
                                                    ),
                                                  ]
                                                },
                                              },
                                            ]),
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "Card",
                {
                  staticStyle: {
                    position: "absolute",
                    right: "35px",
                    bottom: "0",
                    width: "96%",
                    "z-index": "100002",
                  },
                },
                [
                  _c(
                    "Row",
                    {
                      staticStyle: {
                        border: "1px solid #dddddd",
                        "background-color": "#f7f7f7",
                        padding: "10px",
                        "border-radius": "3px",
                      },
                      attrs: { gutter: 16 },
                    },
                    [
                      _c(
                        "Col",
                        { attrs: { span: "24" } },
                        [
                          _c(
                            "Form",
                            {
                              staticClass: "form-input-no-outline",
                              attrs: { "label-position": "top" },
                            },
                            [
                              _c("div", { staticClass: "global-tool-bar" }, [
                                _c("div", { staticClass: "left-bar" }),
                                _c("div", { staticClass: "right-bar" }, [
                                  _c("div", [
                                    _vm._v(
                                      "\n                                        合计:    数量:\n                                        "
                                    ),
                                    _c("span", { staticClass: "red-color" }, [
                                      _vm._v(_vm._s(_vm.totalMainCount)),
                                    ]),
                                    _vm._v(
                                      "\n                                          金额:\n                                        "
                                    ),
                                    _c("span", { staticClass: "red-color" }, [
                                      _vm._v(_vm._s(_vm.totalMainMoney) + "元"),
                                    ]),
                                  ]),
                                ]),
                              ]),
                            ]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }